// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"CompareA_TheComp__7dxz3"};